module.exports = __webpack_public_path__ + "static/homepage-image-0da70c61e7650ee2a936693a0d8ec9dd.png";